export const red = '#C60612';
export const blue = '#01399C';
export const blueOpaque = 'rgba(1, 57, 156, 0.7)';
export const quoteBlue = '#093A9A';
export const brightBlue = '#1173FF';
export const lighterBlue = '#0073FF';
export const darkBlue = '#001B4F';
export const blueGradient = 'linear-gradient(135deg, #102E82 0%, #17287E 19.1%, #02214F 100%)';
export const lightBlue = '#1C93E0';
export const silver = '#D8D8D8';
export const darkGrey = '#050709';
export const darkerGrey = '#575757';
export const grey = '#979797';
export const lightGrey = '#9DABBE';
export const backgroundGrey = '#F7F7F7';
export const transparentGrey = 'color: rgba(255,255,255,0.55)';
export const white = '#FFFFFF';
export const black = '#000000';

export const fontSizes = {
  headline: 55,
};

const GRADIENT_WIDTH = '80%';
const BLACK = 'rgba(1, 22, 53, 1)';
const WIDTH = '133vh';
const HEIGHT = '75vh';

export const gradientDimensions = {
  height: HEIGHT,
  width: WIDTH,
};

export const gradientBackground = `
position: relative;
&:before {
  content: '';
  width: calc(((100%) / 2) + 1px);
  height: 100%;
  background: linear-gradient(270deg, ${BLACK} 0px, ${darkBlue} ${GRADIENT_WIDTH});
  position: absolute;
  left: 0;
  top: 0;
}
&:after {
  content: '';
  width: calc(((100%) / 2) + 1px);
  height: 100%;
  background: linear-gradient(90deg, ${BLACK} 0px, ${darkBlue} ${GRADIENT_WIDTH});
  position: absolute;
  right: 0;
  top: 0;
`;

export const teko = `
    font-family: 'Teko', Helvetica, Arial, sans-serif;
`;

export const tekoLight = `
    font-family: 'Teko-Light', Helvetica, Arial, sans-serif;
`;

export const tekoMedium = `
    font-family: 'Teko-Medium', Helvetica, Arial, sans-serif;
`;

export const tekoSemibold = `
    font-family: 'Teko-Semibold', Helvetica, Arial, sans-serif;
`;

export const roboto = `
    font-family: 'RobotoCondensed', Helvetica, Arial, sans-serif;
`;

export const robotoLight = `
    font-family: 'RobotoCondensed-Light', Helvetica, Arial, sans-serif;
`;

export const robotoBold = `
    font-family: 'RobotoCondensed-Bold', Helvetica, Arial, sans-serif;
`;

export const openSans = `
    font-family: 'OpenSans', Helvetica, Arial, sans-serif;
`;

export const openSansLight = `
    font-family: 'OpenSans-Light', Helvetica, Arial, sans-serif;
`;

export const openSansBold = `
    font-family: 'OpenSans-Bold', Helvetica, Arial, sans-serif;
`;

export const openSansItalic = `
    font-family: 'OpenSans-Italic', Helvetica, Arial, sans-serif;
`;



// WEBPACK FOOTER //
// ./src/utils/theme.js